import { redirect } from 'react-router-dom';

import { cookieJar } from '@consumer-frontend/nc-api';

import { authenticatedEntryRoute } from '../checks';

export const unAuthenticatedGuard = async () => {
  const hasAccessToken = !!cookieJar.getAccessToken();

  if (hasAccessToken) {
    const target = authenticatedEntryRoute();

    if (target) {
      throw redirect(target);
    }
  }
};
